import { render, staticRenderFns } from "./lobby_map.vue?vue&type=template&id=36f5ab21&"
import script from "./lobby_map.vue?vue&type=script&lang=js&"
export * from "./lobby_map.vue?vue&type=script&lang=js&"
import style0 from "./lobby_map.vue?vue&type=style&index=0&id=36f5ab21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports